import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicAdditionalFeesNumberActive({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 45 29"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M27.94 0L25.8 7.65h8.1L36.04 0h3.01l-2.14 7.65h7.31v2.82h-8.1l-2.24 8.06h10.34v2.82H33.1L30.95 29h-3l2.13-7.65h-8.1L19.84 29h-3l2.13-7.65H12v-2.82h7.76L22 10.47H12V7.65h10.8L24.93 0h3.01zm2.93 18.53l2.25-8.06h-8.1l-2.25 8.06h8.1z"
        fill="#F4F5FB"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgPicAdditionalFeesNumberActive.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicAdditionalFeesNumberActive.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicAdditionalFeesNumberActive svgRef={ref} {...props} />
));
export default ForwardRef;
